<template>
  <div id="Task-edit">
    <IForm :label-width="100" ref="formInline" :model="edit" :elem="taskDetailElem" :rules="taskDetailRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col span="10">
            <Row>
              <Col span="24">
                <FormItem label="体检任务" prop="taskId">
                  <el-select v-model.trim="edit.taskId" placeholder="体检任务"
                             clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                             style="width: 100%" @change="changeTask" :disabled="disabled" class="input-disabled">
                    <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                               @click.native="handleTaskChange(item)" style="width:100%;z-index: 9999;"/>
                  </el-select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="体检人群" prop="crowdId">
                  <Select v-model="edit.crowdId" :multiple="true" :disabled="true">
                    <Option v-for="item in crowdList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="姓名" prop="name">
                  <el-autocomplete v-model="edit.name" value-key="name" size="mini" clearable placeholder="请输入关键词"
                       :trigger-on-focus="false" :hide-loading="false" :highlight-first-item="true"
                       @select="(rowData)=>{selectStudent(rowData)}"
                       :fetch-suggestions="(query, cb)=>{queryStudent(query, cb)}" :disabled="disabled" style="width: 100%;">
                    <!-- 自定义下拉选项内容 -->
                    <template #default="{ item }">
                      <div class="autocomplete-item">
                        <div class="alias-text">{{ item.name + "(" + item.idCard + ")"}}</div>
                      </div>
                    </template>
                  </el-autocomplete>

                </FormItem>
              </Col>

            </Row>
            <Row>
              <Col span="12">
                <FormItem label="证件类型" prop="idCardType">
                  <Select v-model="edit.idCardType" @on-change="changeIdCardType" :disabled="disabled">
                    <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="证件号码" prop="idCard" :required="edit.idCardType===2?false:true">
                  <Input v-model="edit.idCard" type="text" placeholder="请输入证件号码" @on-change="cardchange"
                         maxlength="20" :disabled="disabled || edit.idCardType === 2"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="性别" prop="gender">
                  <Select v-model="edit.gender" :disabled="disabled">
                    <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="出生日期" prop="birthday">
                  <DatePicker :value="edit.birthday" :editable="false" :disabled="disabled" @on-change="changeBirthday"
                              type="date" format="yyyy-MM-dd" placeholder="出生日期" style="width: 100%;"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="学校名称" prop="schoolId">
                  <Select v-model="edit.schoolId" :disabled="true">
                    <Option v-for="item in schoolsList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="年级" prop="gradeId">
                  <el-select v-model.trim="edit.gradeId" placeholder="年级"
                             clearable filterable size="small" transfer="true"
                             :popper-append-to-body="false" @change="changeGrade" :disabled="disabled" style="width:100%;">
                    <el-option v-for="item in gradesList" :key="item.id" :label="item.name" :value="item.id"
                               @click.native="handleGradeChange(item)" style="width:100%;z-index: 9999;"/>
                  </el-select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="班级" prop="classesId">
                  <el-select v-model.trim="edit.classesId" placeholder="班级"
                             clearable filterable size="small" transfer="true"
                             :popper-append-to-body="false" style="width: 100%;" :disabled="disabled">
                    <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id"
                               @click.native="handleClassChange(item)" style="width:100%;z-index: 9999;"/>
                  </el-select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="民族" prop="nationsId">
                  <Select v-model="edit.nationsId" :disabled="disabled">
                    <Option v-for="item in nationsList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="手机号码" prop="phone">
                  <Input v-model="edit.phone" type="number" placeholder="请输入手机号码" maxlength="11" :disabled="disabled"/>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="固定电话" prop="phone">
                  <Input v-model="edit.telPhone" type="tel" placeholder="请输入固定电话" :disabled="disabled" maxlength="15"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="现住址" prop="currentAddress">
                  <Input v-model="edit.currentAddress" type="text" placeholder="请输入现住址" :disabled="disabled" maxlength="125"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="户籍地" prop="address">
                  <Input v-model="edit.address" type="text" placeholder="请输入户籍地" :disabled="disabled" maxlength="125"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="来市时间" prop="arrivalDate">
                  <DatePicker :value="edit.arrivalDate" :editable="false" :disabled="disabled"
                              @on-change="changeArrivalDate" type="month" format="yyyy-MM" placeholder="来市时间" style="width: 100%;"/>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="居住类型" prop="resideCondition">
                  <Select v-model="edit.resideCondition" :disabled="disabled">
                    <Option v-for="item in enums.resideConditionList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="入户情况" prop="occupancyType">
                  <Select v-model="edit.occupancyType" :disabled="disabled">
                    <Option v-for="item in enums.occupancyTypeList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem  label="入户时间" prop="occupancyDate">
                  <DatePicker :value="edit.occupancyDate" :editable="false" :disabled="disabled"
                              @on-change="changeOccupancyDate" type="month" format="yyyy-MM" placeholder="入户时间" style="width: 100%;"/>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="入学时间" prop="entryDate">
                  <DatePicker :value="edit.entryDate" :editable="false" :disabled="disabled"
                              @on-change="changeEntryDate" type="date" format="yyyy-MM-dd" placeholder="入学时间" style="width: 100%;"/>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="居住类型" prop="resideType">
                  <Select v-model="edit.resideType"  style="width: 100%;" :disabled="disabled">
                    <Option v-for="item in enums.resideTypeList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="既往病史" prop="pastMedicalHistorys">
                  <MyCheckBox :enumList="enums.pastMedicalHistoryList" :ignore-list="['1']" :dataList.sync="pastMedicalHistorys" :dataStr.sync="edit.pastMedicalHistory" :disabled="disabled">
                    <Input v-model="edit.pastMedicalHistoryOther" v-if="edit.pastMedicalHistory.indexOf('7') !== -1" placeholder="请输入"/>
                  </MyCheckBox>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem label="过敏史" prop="allergyHistory">
                  <RadioGroup v-model="edit.allergyHistory">
                    <Radio v-for="item in enums.allergyHistoryList" v-bind:key="item.code" :label="item.code" @dblclick.native.prevent="()=>{form.other = null}" :disabled="disabled">{{item.value}}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="12">
                <Input v-model="edit.allergyHistoryOther" v-if="edit.allergyHistory === 2" placeholder="请输入" :disabled="disabled"/>
              </Col>
            </Row>
            <Row>
              <Col span="8" style="text-align: left;">
                <FormItem label="传染病接触史" prop="infectionHistory">
                  <RadioGroup v-model="edit.infectionHistory">
                    <Radio v-for="item in enums.infectionHistoryList" v-bind:key="item.code"  :label="item.code" @dblclick.native.prevent="()=>{form.other = null}" :disabled="disabled">{{item.value}}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="12" style="text-align: left;">
                  <Input v-model="edit.infectionHistoryOther" v-if="edit.infectionHistory === 2" placeholder="请输入" :disabled="disabled"/>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <button type="button" class="ivu-btn ivu-btn-primary" @click="addFamilyMembers(1)"><i class="el-icon-plus" />新增亲属</button>
              </Col>
            </Row>

            <Row v-if=" familyMembers && familyMembers.length > 0">
              <Col>
                <vxe-table border class="mytable-scrollbar" ref="familyMember"
                           :row-config="{isCurrent: true, isHover: true}" :custom-config="{storage: true,visible:true}" :data="familyMembers"
                           :sort-config="{trigger: 'cell'}" style="margin-top: 10px;">
                  <vxe-column  v-for="item in columns" :field="item.key" :title="item.title" :visible="item.visible"
                               :formatter="item.formatter?item.formatter:''" :fixed="item.fixed ? item.fixed : ''":width="item.width">
                    <template #default="{ row }">
                      <Select v-model="row[item.key]" v-if="item.key == 'type'" placement="top" style="z-index: 9999;" transfer>
                        <Option v-for="item in enums.familyMemberTypeList" :value="item.code" v-bind:key="item.code"
                                style="z-index: 9999;">{{ item.value }}</Option>
                      </Select>
                      <Select v-model="row[item.key]" v-else-if="item.key.indexOf('idcardType') !== -1" placement="top" transfer>
                        <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                      </Select>
                      <el-input v-model="row[item.key]" placeholder="请输入身份证" maxlength="18" size="mini" v-else-if="item.key == 'idcard'"  @input="idcardInput(row)" />
                      <Select v-model="row[item.key]" v-else-if="item.key.indexOf('gender') !== -1" placement="top" transfer>
                        <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
                      </Select>
                      <DatePicker :value="row[item.key]" :editable="false" v-else-if="item.key.indexOf('birthday') !== -1"
                                  @on-change="(val)=>{row.birthday=val}"
                                  type="date" format="yyyy-MM-dd" placeholder="出生日期" placement="top" transfer></DatePicker>
                      <el-input v-model="row[item.key]" placeholder="请输入" maxlength="125" size="mini" v-else/>
                    </template>
                  </vxe-column>

                  <vxe-column title="操作" width="180" show-overflow fixed="right">
                    <template #default="{ row }">
                      <vxe-button type="text" class="txtBlue" @click="addFamilyMembers(-1,row.rowId)">删除</vxe-button>
                      &nbsp;|&nbsp;
                      <span v-if="row.status == 2">默认家属</span>
                      <vxe-button type="text" class="txtBlue" @click="setDefault(row.rowId)"  v-if="row.status == 1">设为默认家属</vxe-button>
                    </template>
                  </vxe-column>
                </vxe-table>
              </Col>
            </Row>
          </Col>

          <!-- 右边内容区 -->
          <Col span="14">
            <TaskDetailTemplate ref="taskTemplate" :packagesNames="packagesNameList" :taskProject="taskProjects"
                          :packageDisabled="packageDisabled" :itemDisabled="itemDisabled"
                          :physicalType.sync="edit.type" :bloodTubeRemark.sync="edit.bloodTubeRemark" @setPhysicalType="setPhysicalType"
                          @setPackageId="setPackageId" @setBloodTubeCount="setBloodTubeCount"
                          style="margin-left: 10px;"/>
          </Col>
        </Row>
      </div>

    </IForm>

  </div>
</template>
<script>
import {_get, _audit, _save} from "@/services/taskDetail/taskDetail";
import {_gradesList,_classesList,_studentsList} from "@/services/studentManage/studentManage";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
import TaskDetailTemplate from "@/views/preScreening/taskDetail/TaskDetailTemplate.vue";
import TaskTemplate from "@/views/preScreening/task/TaskTemplate.vue";
export default {
  name: "TaskDetail",
  components: {TaskTemplate, TaskDetailTemplate},
  mixins: [mixins],
  data() {
    return {
      enums:enums,
      disabled:false,
      packageDisabled:false,
      itemDisabled:false,
      show:false,
      columns : [
        {
          title: "姓名",
          key: "name",
          visible: true,
          width:75
        },
        {
          title: "亲属关系",
          key: "type",
          visible: true,
          width:160
        },
        {
          title: "证件类型",
          key: "idcardType",
          visible: true,
          width:200
        },
        {
          title: "证件号码",
          key: "idcard",
          visible: true,
          width:200
        },
        {
          title: "性别",
          key: "gender",
          visible: true,
          width:200
        },
        {
          title: "出生日期",
          key: "birthday",
          visible: true,
          width:200
        },
        {
          title: "手机号码",
          key: "phone",
          visible: true,
          width:200
        },
        {
          title: "固定电话",
          key: "telPhone",
          visible: true,
          width:200
        },
      ],
      taskProjects:[],
      pastMedicalHistorys:[],
      gradesList:[],
      classList:[],
      packagesNameList:[],
      edit: {
        taskId: "",
        crowdId: [],
        name: "",
        idCardType: "",
        idCard: "",
        gender: "",
        birthday: "",
        age: "",
        phone: "",
        telPhone: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        nationsId: "",
        currentAddress: "",
        address: "",
        entryDate: "",
        arrivalDate: "",
        resideType: "",
        resideCondition: "",
        occupancyType: "",
        occupancyDate: "",
        educationalLevel: "",
        familySituation: "",
        nurseryDate: "",
        pastMedicalHistory: "1",
        pastMedicalHistoryOther: "",
        allergyHistory: 1,
        allergyHistoryOther: "",
        infectionHistory: 1,
        infectionHistoryOther: "",
        source: "",
        type: "",
        remark: "",
        bloodTubeRemark: "",
        familyMembers:[],
        packagesId:"",
        taskPackage:{}
      },
      init: "",
      taskDetailElem:[],
      taskDetailRule: {
        taskId: [
          {required: true, message: '请选择体检任务', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {maxlength:50,message:"姓名长度不能超过50个字",trigger: 'blur'}
        ],
        idCardType: [
          {required: true, message: "请选择证件类型", type:'number'}
        ],
        idCard: [
          {validator:function(rule, value, callback){
              if ((!this.edit.idCardType || this.edit.idCardType != 2) && (!value || value.length == 0)) {
                callback(new Error('证件号码不能为空'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        gender: [
          {required: true, message: "请选择性别", type:'number'}
        ],
        birthday: [
          {validator:function(rule, value, callback){
              if (!this.edit.birthday || this.edit.birthday.length === 0) {
                callback(new Error('请选择出生日期'));
              } else if (!this.isValidDateBasic(this.edit.birthday)) {
                callback(new Error('请输入正确的出生日期'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        gradeId: [
          {required: true, message: "请选择年级", type:'number'}
        ],
        classesId: [
          {required: true, message: "请选择班级", type:'number'}
        ]
      },
    };
  },
  watch:{
    /*'edit.idCard': {
      handler(newVal){
        if(newVal && newVal.length == 18){
          this.edit.birthday = newVal.substring(6, 10) + "-" + newVal.substring(10, 12) + "-" + newVal.substring(12, 14);
          let sex = newVal.substring(16, 17);
          this.edit.gender = parseInt(sex) % 2 == 0 ? 2 : 1;
        }
      }
    },*/
  },
  computed:{
    familyMembers(){
      if (this.edit.familyMembers){
        let tempList = Object.assign([],this.edit.familyMembers)
        tempList.forEach(it=>{ it.rowId = Math.random()})
        this.edit.familyMembers = tempList
        return this.edit.familyMembers;
      }else{
        this.edit.familyMembers=[];
        return this.edit.familyMembers;
      }
    }
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    isValidDateBasic(dateString) {
      const date = new Date(dateString);
      // 检查 date 是否是 Date 的实例，并且其时间戳不是 NaN
      return date instanceof Date && !isNaN(date.getTime());
    },
    cardchange(){
      if((this.edit.idCardType && this.edit.idCardType == 1 && this.edit.idCard && this.edit.idCard.length == 18)
        || (this.edit.idCard && this.edit.idCard.length == 18 && this.edit.idCard.startsWith("[0-9]+"))){
        this.edit.birthday = this.edit.idCard.substring(6, 10) + "-" + this.edit.idCard.substring(10, 12) + "-" + this.edit.idCard.substring(12, 14);
        let sex = this.edit.idCard.substring(16, 17);
        this.edit.gender = parseInt(sex) % 2 == 0 ? 2 : 1;
      }
    },
    idcardInput(row){
      if(row.idcard && row.idcard.length == 18) {
        let yearBirth = row.idcard.substring(6, 10);
        let monthBirth = row.idcard.substring(10, 12);
        let dayBirth = row.idcard.substring(12, 14);
        let _birthday = yearBirth + "-" + monthBirth + "-" + dayBirth;
        let _gender = (row.idcard.substring(16, 17) % 2 == 0) ? 2 : 1;

        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index];
          let birthday = temp.birthday;
          let gender = temp.gender;
          if (temp.rowId === row.rowId){
            birthday = _birthday;
            gender = _gender;
          }
          this.$set(this.edit.familyMembers, index,
              {
                id: temp.id,
                rowId: temp.rowId,
                name: temp.name,
                type: temp.type,
                idcardType: temp.idcardType,
                idcard: temp.idcard,
                gender: gender,
                birthday: birthday,
                phone: temp.phone,
                telPhone: temp.telPhone,
                status: temp.status
              }
          )
        }
      }
    },
    addFamilyMembers(type, id){
      if (type > 0){
        this.edit.familyMembers.push({ rowId: Math.random(), name:"",type:"",idcardType:"",idcard:"",gender:"",birthday:"",phone:"",telPhone:"",status: this.edit.familyMembers.length == 0 ? 2 : 1});
      }else{
        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index]
          if (temp.rowId === id){
            this.edit.familyMembers.splice(index,1);
          }
        }
      }
    },
    setDefault(id) {
      for (let index = 0; index < this.edit.familyMembers.length; index++) {
        let temp = this.edit.familyMembers[index]
        let status = 1;
        if (temp.rowId === id) {
          status = 2;
        }
        this.$set(this.edit.familyMembers, index,
            {
              id: temp.id,
              rowId: temp.rowId,
              name: temp.name,
              type: temp.type,
              idcardType: temp.idcardType,
              idcard: temp.idcard,
              gender: temp.gender,
              birthday: temp.birthday,
              phone: temp.phone,
              telPhone: temp.telPhone,
              status: status
            }
        )
      }
    },
    changeTask(val){
      this.edit.taskId = val;
    },
    queryStudent(query, cb){
      _studentsList({name: query}).then(res=>{
        if(res.errcode == 1 && res.data){
          let dataList = res.data;
          let tempOptions = [];
          dataList.forEach(item =>{
            tempOptions.push(item)
          })
          this.$nextTick(()=>{
            cb(tempOptions);
          })
        }else{
          this.$nextTick(()=>{
            cb([]);
          })
        }
      })
    },
    selectStudent(rowData){
      this.edit.id = "";
      this.edit.studentId = rowData.studentId;
      this.edit.idCardType = rowData.idCardType;
      this.edit.idCard = rowData.idCard;
      this.edit.gender = rowData.gender;
      this.edit.birthday = rowData.birthday;
      this.edit.age = rowData.age;
      this.edit.phone = rowData.phone;
      this.edit.telPhone = rowData.telPhone;
      this.edit.nationsId = rowData.nationsId;
      this.edit.currentAddress = rowData.currentAddress;
      this.edit.address = rowData.address;
      this.edit.entryDate = rowData.entryDate;
      this.edit.arrivalDate = rowData.arrivalDate;
      this.edit.resideType = rowData.resideType;
      this.edit.resideCondition = rowData.resideCondition;
      this.edit.occupancyType = rowData.occupancyType;
      this.edit.occupancyDate = rowData.occupancyDate;
      this.edit.educationalLevel = rowData.educationalLevel;
      this.edit.familySituation = rowData.familySituation;
      this.edit.nurseryDate = rowData.nurseryDate;
      this.edit.pastMedicalHistory = rowData.pastMedicalHistory;
      this.edit.pastMedicalHistoryOther = rowData.pastMedicalHistoryOther;
      this.edit.allergyHistory = rowData.allergyHistory;
      this.edit.allergyHistoryOther = rowData.allergyHistoryOther;
      this.edit.infectionHistory = rowData.infectionHistory;
      this.edit.infectionHistoryOther = rowData.infectionHistoryOther;
      this.edit.familyMembers = rowData.familyMembers;
      this.edit.studentId = rowData.id;
      this.edit.residentId = rowData.residentId;
      this.changeSchool(this.edit.schoolId, null, null);
    },
    changeIdCardType(val){
      if(val && val == 1) {
        this.cardchange();
      }else if(val && val == 2){
        this.edit.idCard = "";
      }
    },
    handleTaskChange(item) {
      this.packagesNameList = [];
      this.edit.taskId = item.id;
      this.edit.crowdId = item.crowdId;
      this.edit.schoolId = item.schoolId.toString();
      this.show = true;
      this.packageDisabled = false;
      this.$nextTick(()=>{
        if(item.taskPackageProject&&item.taskPackageProject.length>0){
          item.taskPackageProject.forEach(item=>{
            this.packagesNameList.push({label: item.packagesName,value: item.packagesId})
          });
          this.taskProjects = item.taskPackageProject;
          this.edit.packagesId = item.taskPackageProject[0].packagesId;
        }
      });
      this.changeSchool(this.edit.schoolId, null, null);
    },
    handleGradeChange(item) {
      this.edit.gradeId = item.id;
    },
    handleClassChange(item){
      this.edit.classesId = item.id;
    },
    changeSchool(schoolId, gradeId, classesId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.edit.schoolId = schoolId;
        this.edit.gradeId = "";
        this.gradesList =[]
        if (res.errcode === 1 && res.data){
          this.gradesList = res.data;
        }

        if(gradeId){
          this.changeGrade(gradeId, classesId);
        }
      })
    },
    changeGrade(gradeId, classesId){
      if(!gradeId){
        return;
      }
      _classesList({schoolId:this.edit.schoolId, gradeId : gradeId}).then(res=>{
        this.edit.gradeId = gradeId;
        this.edit.classesId = "";
        this.classList =[]
        if (res.errcode === 1 && res.data){
          this.classList = res.data;
          this.edit.classesId = (classesId ? classesId : "");
        }
      })
    },
    setFormEle(){
      this.studentElem=[]
    },
    changeArrivalDate(val){
      this.edit.arrivalDate= val;
    },
    changeOccupancyDate(val){
      this.edit.occupancyDate= val;
    },
    changeEntryDate(val){
      this.edit.entryDate= val;
    },
    changeBirthday(val){
      this.edit.birthday= val;
    },
    handleModal(row) {
      this.packagesNameList = [];
      this.taskProjects = [];
      this.gradesList = [];
      this.classList = [];
      this.applyTaskList();
      this.applyCrowdList();
      this.applySchoolsList();
      this.applyNationsList();

      this.$refs.taskTemplate.packagePanelConfigs1 = [];
      this.taskProjects=[];

      this.$refs["formInline"].handleReset();
      if (!row) {
        this.disabled = false;
        this.packageDisabled = false;
        this.handleCreate();
      } else {
        this.packageDisabled = row.signUpStatus && row.signUpStatus == 2 ? true : false;
        this.disabled = row.signUpStatus && row.signUpStatus == 2 ? true : false;
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.setFormEle();
      this.itemDisabled = false;
      this.packageDisabled = false;
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        this.edit = Object.assign({}, res.data);
        this.edit.schoolId = this.edit.schoolId.toString();
        this.changeSchool(this.edit.schoolId, this.edit.gradeId, this.edit.classesId);
        delete this.edit.gradeId;
        if(this.edit.pastMedicalHistory){
          this.pastMedicalHistorys = this.edit.pastMedicalHistory.split(",");
        }

        this.packagesNameList = [];
        // this.packageDisabled = false;
        this.$nextTick(()=>{
          if(this.edit.packagesInfo){
            this.taskProjects = [];
            this.show = true;
            this.itemDisabled = false;
            // this.packageDisabled = true;
            this.packagesNameList.push({label: this.edit.packagesInfo.packagesName,value: this.edit.packagesInfo.packagesId})
            this.taskProjects.push(this.edit.packagesInfo);
            this.edit.packagesId = this.edit.packagesInfo.packagesId;
          }
        });

        this.setFormEle();
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      if(this.edit.signUpStatus && this.edit.signUpStatus != 2){
        this.toSubmit();
      }else{
        this.$refs["formInline"].handleSubmit('form');
      }
    },
    toSubmit() {
      if(this.edit.signUpStatus && this.edit.signUpStatus != 2){
        this.audit();
      }else{
        this.save();
      }
    },
    setPhysicalType(physicalType){
      this.edit.type = physicalType;
    },
    setPackageId(packageId){
      this.edit.packageId = packageId;
    },
    setBloodTubeCount(bloodTubeCount){
      this.edit.bloodTubeRemark = bloodTubeCount;
    },
    save(){
      let packagePanelConfigs = this.$refs.taskTemplate.packagePanelConfigs;
      let taskPackage = {};
      packagePanelConfigs.forEach(item => {
        if(item.search.packagesId == this.edit.packagesId){
          taskPackage.packagesId = item.search.packagesId;
          taskPackage.projects = item.taskProjects;
          taskPackage.lisProjects = item.taskLisProjects;
        }
      });
      this.edit.taskPackage = taskPackage;
      if(this.edit.type && this.edit.type === 1){
        this.edit.bloodTubeRemark = "";
      }

      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.taskProjects = [];
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    audit(){
      if(this.edit.signUpStatus && this.edit.signUpStatus == 2){
        this.$message.success("不能操作已审核的数据");
        return;
      }

      let packagePanelConfigs = this.$refs.taskTemplate.packagePanelConfigs;
      let taskPackage = {};
      packagePanelConfigs.forEach(item => {
        if(item.search.packagesId == this.edit.packagesId){
          taskPackage.packagesId = item.search.packagesId;
          taskPackage.projects = item.taskProjects;
          taskPackage.lisProjects = item.taskLisProjects;
        }
      });
      this.edit.taskPackage = taskPackage;

      if(this.edit.type && this.edit.type === 1){
        this.edit.bloodTubeRemark = "";
      }

      _audit(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("审核成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
.txtBlue{color: #2d8cf0;}
.i-content-task-detail {
  & .i-search-bar {display: flex;justify-content: space-between;}
  & .i-content-task-detail {
    min-height: auto;
    & .ivu-card-body {padding: 0;}
  }
}

.demo-split {
  display: flex;
  gap: 10px;
  & .demo-split-left {flex: 1;}
  & .demo-split-right {position: sticky;top: 0px;max-height: 1000px;overflow-y: hidden;}
}

/deep/ .ivu-btn>.ivu-icon {line-height: 1.5;font-size: 18px;}
/deep/ .ivu-btn-group-vertical>.ivu-btn {min-width: 20px;}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-checkbox-disabled+span {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.el-input.is-disabled .el-input__inner {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
/deep/.el-input--mini .el-input__inner {height: 35px;line-height: 35px;}
/deep/.el-input--suffix .el-input__inner {padding-right: 35px;}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {background-color: #409EFF;border-color: #409EFF;}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}
/deep/ .ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;color: #515a6e;}
/deep/ .ivu-radio-disabled .ivu-radio-inner:after{  background-color: #409EFF;}

</style>
